import { brandedString } from 'src/helpers/brandedString';

// @todo: Ideally schema would expose them
export const InvitationActions = brandedString({
  READ: 'invitations:invitation.read',
  SEND: 'invitations:invitation.send',
});
